/**
 * @generated SignedSource<<7a6bffd310c33bbb6c1fa9199a23e7d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserFlag = "FinishedSetup" | "NoteIntroduction" | "RoutineIntroduction" | "TodoIntroduction";
export type FinishedSetupScreenMutation$variables = Record<PropertyKey, never>;
export type FinishedSetupScreenMutation$data = {
  readonly me: {
    readonly addFlag: {
      readonly flags: ReadonlyArray<UserFlag>;
      readonly id: string;
    };
  };
};
export type FinishedSetupScreenMutation = {
  response: FinishedSetupScreenMutation$data;
  variables: FinishedSetupScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MeMutation",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "flag",
            "value": "FinishedSetup"
          }
        ],
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "addFlag",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "flags",
            "storageKey": null
          }
        ],
        "storageKey": "addFlag(flag:\"FinishedSetup\")"
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FinishedSetupScreenMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "FinishedSetupScreenMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "ae85b1ec649ed33d7f7f6ed33330a40d",
    "id": null,
    "metadata": {},
    "name": "FinishedSetupScreenMutation",
    "operationKind": "mutation",
    "text": "mutation FinishedSetupScreenMutation {\n  me {\n    addFlag(flag: FinishedSetup) {\n      id\n      flags\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "76a4fbc70094c1bb9b47ca3f38401b6d";

export default node;
